module.exports = __webpack_public_path__ + "static/media/haussii_ja_nakei.f60e4c18.png";